import {
	Blanket,
	BlanketImage,
	BlanketInfo,
} from "@/components/core/blanket.tsx";
import DataTable, { type ColumnDef } from "@/components/core/data-table";
import { IconDatabaseExclamation } from "@tabler/icons-react";

const caseCollaboratorsColumns: ColumnDef[] = [
	{
		id: "name",
		label: "Name",
		cell: ({ data }) => (
			<span className="text-foreground-dark font-semibold">{data.name}</span>
		),
	},
	{
		id: "email",
		label: "Email",
		cell: ({ data }) => data.email,
	},
	{
		id: "date_added",
		label: "Date Added",
		cellClassName: "text-right",
		headerClassName: "text-right",
		cell: ({ data }) => data.date_added,
	},
];

const caseCollaborators = [
	{
		id: 1,
		name: "Alice Johnson",
		email: "alice@example.com",
		date_added: "2024-02-20",
	},
	{
		id: 2,
		name: "Bob Smith",
		email: "bob@example.com",
		date_added: "2024-02-19",
	},
	{
		id: 3,
		name: "Charlie Brown",
		email: "charlie@example.com",
		date_added: "2024-02-18",
	},
];

export const CaseCollaborators = () => {
	return (
		<div className="flex flex-col w-full mt-6">
			{caseCollaborators.length > 0 ? (
				<DataTable
					className="border-collapse"
					data={caseCollaborators}
					columns={caseCollaboratorsColumns}
					stickyHead={false}
					stickyCol={false}
					showBorder={true}
					compact={false}
					showToolbar={true}
				/>
			) : (
				<div className="flex flex-col w-full rounded-md border border-border/50">
					<Blanket width="sm">
						<BlanketImage
							icon={<IconDatabaseExclamation size={24} stroke={1.5} />}
						/>
						<BlanketInfo
							title="No Data"
							message="No available data for now. Please check back later or refresh the page."
						/>
					</Blanket>
				</div>
			)}
		</div>
	);
};
